"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var redux_1 = require("redux");
var Store = (function () {
    function Store(reducer, initialState, enhancer) {
        var _this = this;
        this.reducer = reducer;
        this.dispatch = function (action) {
            return _this.redux.dispatch(action);
        };
        this.getState = function () {
            return _this.redux.getState();
        };
        this.subscribe = function (listener) {
            return _this.redux.subscribe(listener);
        };
        this.replaceReducer = function (reducer) {
            _this.reducer = reducer;
            _this.redux.replaceReducer(_this.reducer);
        };
        this.action = function (type) {
            return new StoreAction(_this, type);
        };
        this.initial = initialState;
        this.redux = redux_1.createStore(this.reducer, initialState || this.reducer(undefined, { type: '', payload: undefined }), enhancer);
    }
    return Store;
}());
exports.Store = Store;
var StoreAction = (function () {
    function StoreAction(store, type) {
        this.store = store;
        this.type = type;
    }
    StoreAction.prototype.dispatch = function (payload) {
        return this.store.dispatch({ type: this.type, payload: payload });
    };
    return StoreAction;
}());
exports.StoreAction = StoreAction;
//# sourceMappingURL=store.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@ngfk/ts-redux/dist/store.js
// module id = 54
// module chunks = 0